export const ACTION_CODE = 'BANK' + '_ACTION';
